export default __webpack_public_path__ + "static/media/workFromHome.a9b1e464.png";